import {
  GET_BOARD_FORMS,
  GET_FORM_BY_ID,
  CREATE_FORM,
  UPDATE_FORM,
  SET_FORM_ARCHIVE,
  DELETE_FORM,
  CREATE_TASK_FORM,
  CREATE_TASK_MAP_FORM,
  UPDATE_TASK_FORM,
  UPDATE_TASK_MAP_FORM,
  DELETE_TASK_FORM,
  DELETE_TASK_MAP_FORM,
  SET_FORMS_LOADING,
  SET_FORMS_ERROR,
  CLEAR_FORM_STATE,
  CLEAR_CURRENT_FORM,
  GET_COMPLETED_FORMS,
  GET_COMPLETED_FORM_BY_ID,
  SUBMIT_COMPLETED_FORM,
  DELETE_COMPLETED_FORM,
  SET_COMPLETED_FORMS_LOADING,
  SET_COMPLETED_FORMS_ERROR,
  CLEAR_COMPLETED_FORMS_STATE,
  CLEAR_CURRENT_COMPLETED_FORM,
  GET_FORM_RESPONSE_STATS,
  SET_FORM_RESPONSE_STATS_LOADING,
  SET_FORM_RESPONSE_STATS_ERROR,
  CLEAR_FORM_RESPONSE_STATS,
  GET_FORM_CATEGORIES,
  SET_FORM_CATEGORIES_LOADING,
  SET_FORM_CATEGORIES_ERROR,
  GET_FORM_DEPARTMENTS,
  SET_FORM_DEPARTMENTS_LOADING,
  SET_FORM_DEPARTMENTS_ERROR,
  GET_FORM_STATUSES,
  SET_FORM_STATUSES_LOADING,
  SET_FORM_STATUSES_ERROR,
  GET_PUBLIC_FORM_BY_ID,
  SET_PUBLIC_FORM_LOADING,
  SET_PUBLIC_FORM_ERROR,
  CLEAR_PUBLIC_FORM,
  SUBMIT_PUBLIC_FORM,
  SET_PUBLIC_FORM_SUBMIT_LOADING,
  SET_PUBLIC_FORM_SUBMIT_ERROR,
  GET_PUBLIC_FORM_RECORD,
  SET_PUBLIC_FORM_RECORD_LOADING,
  SET_PUBLIC_FORM_RECORD_ERROR,
  PUBLIC_FORM_RECORD_REPLY,
  REPLY_COMPLETED_FORM,
  SET_COMPLETED_FORM_TICKET_STATUS,
  SET_COMPLETED_FORM_WORKFLOW_STATE,
} from "./FormType";

const INITIAL_FORMS_STATE = {
  items: [],
  tasksItems: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0,
  },
  currentForm: null,
  loading: false,
  error: null,
  categories: [],
  categoriesLoading: false,
  categoriesError: null,
  departments: [],
  departmentsLoading: false,
  departmentsError: null,
  statuses: [],
  statusesLoading: false,
  statusesError: null,
  publicForm: null,
  publicFormLoading: false,
  publicFormError: null,
  publicFormSubmitLoading: false,
  publicFormSubmitError: null,
  publicFormSubmitted: null,
  publicFormRecord: null,
  publicFormRecordLoading: false,
  publicFormRecordError: null,
};

const INITIAL_COMPLETED_FORMS_STATE = {
  items: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0,
  },
  filterFormID: null,
  currentCompletedForm: null,
  loading: false,
  error: null,
  formResponseStats: null,
  formResponseStatsLoading: false,
  formResponseStatsError: null,
};

const updateFormInList = (items, updatedForm) => {
  const index = items.findIndex((f) => f._id === updatedForm._id);
  if (index === -1) return items;
  const next = [...items];
  next[index] = updatedForm;
  return next;
};

const removeFormFromList = (items, formId) =>
  items.filter((f) => f._id !== formId);

const updateCompletedFormInList = (items, updatedItem) => {
  const index = items.findIndex((f) => f._id === updatedItem._id);
  if (index === -1) return items;
  const next = [...items];
  next[index] = updatedItem;
  return next;
};

const removeCompletedFormFromList = (items, completedFormDataId) =>
  items.filter((f) => f._id !== completedFormDataId);

export const FormReducer = (
  state = {
    ...INITIAL_FORMS_STATE,
    completedForms: INITIAL_COMPLETED_FORMS_STATE,
  },
  action,
) => {
  switch (action.type) {
    case SET_FORMS_LOADING:
      return {
        ...state,
        loading: action.Payload,
      };

    case SET_FORMS_ERROR:
      return {
        ...state,
        error: action.Payload,
        loading: false,
      };

    case GET_BOARD_FORMS:
      return {
        ...state,
        items: action.Payload.items ?? state.items,
        tasksItems: action.Payload.tasksItems ?? state.tasksItems,
        pagination: action.Payload.pagination ?? state.pagination,
        error: null,
      };

    case CREATE_TASK_FORM: {
      const { TaskID, items } = action.Payload || {};
      if (!items || !Array.isArray(items)) return state;
      const rest = (state.tasksItems || []).filter(
        (t) => t.TaskID !== TaskID || t.TaskMapID != null,
      );
      const withTaskId = items.map((i) => ({ ...i, TaskID }));
      return { ...state, tasksItems: [...rest, ...withTaskId], error: null };
    }
    case CREATE_TASK_MAP_FORM: {
      const { TaskID, TaskMapID, items } = action.Payload || {};
      if (!items || !Array.isArray(items)) return state;
      const rest = (state.tasksItems || []).filter(
        (t) => t.TaskID !== TaskID || t.TaskMapID !== TaskMapID,
      );
      const withIds = items.map((i) => ({ ...i, TaskID, TaskMapID }));
      return { ...state, tasksItems: [...rest, ...withIds], error: null };
    }

    case UPDATE_TASK_FORM:
    case UPDATE_TASK_MAP_FORM: {
      const items = action.Payload?.items;
      const formId = action.Payload?.FormID;
      if (!items || !Array.isArray(state.tasksItems) || !formId) return state;
      const formIdStr = formId?.toString?.() ?? formId;
      const updated = Array.isArray(items)
        ? items.find((x) => (x._id?.toString?.() ?? x._id) === formIdStr)
        : null;
      const next = state.tasksItems.map((t) =>
        (t._id?.toString?.() ?? t._id) === formIdStr && updated
          ? { ...t, ...updated }
          : t,
      );
      return { ...state, tasksItems: next, error: null };
    }

    case DELETE_TASK_FORM:
    case DELETE_TASK_MAP_FORM:
      return {
        ...state,
        tasksItems: (state.tasksItems || []).filter(
          (t) => t._id !== action.Payload?.FormID,
        ),
        error: null,
      };

    case GET_FORM_BY_ID:
      return {
        ...state,
        currentForm: action.Payload,
        error: null,
      };

    case CREATE_FORM:
      return {
        ...state,
        items: [action.Payload, ...state.items],
        currentForm: action.Payload,
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
        },
        error: null,
      };

    case UPDATE_FORM:
      return {
        ...state,
        items: updateFormInList(state.items, action.Payload),
        currentForm:
          state.currentForm?._id === action.Payload._id
            ? action.Payload
            : state.currentForm,
        error: null,
      };

    case SET_FORM_ARCHIVE:
      return {
        ...state,
        items: updateFormInList(state.items, action.Payload),
        currentForm:
          state.currentForm?._id === action.Payload._id
            ? action.Payload
            : state.currentForm,
        error: null,
      };

    case DELETE_FORM:
      return {
        ...state,
        items: removeFormFromList(state.items, action.Payload),
        currentForm:
          state.currentForm?._id === action.Payload ? null : state.currentForm,
        pagination: {
          ...state.pagination,
          total: Math.max(0, state.pagination.total - 1),
        },
        error: null,
      };

    case CLEAR_FORM_STATE:
      return {
        ...state,
        ...INITIAL_FORMS_STATE,
        completedForms: state.completedForms,
      };

    case CLEAR_CURRENT_FORM:
      return {
        ...state,
        currentForm: null,
      };

    case SET_COMPLETED_FORMS_LOADING:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          loading: action.Payload,
        },
      };

    case SET_COMPLETED_FORMS_ERROR:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          error: action.Payload,
          loading: false,
        },
      };

    case GET_COMPLETED_FORMS:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          items: action.Payload.items ?? state.completedForms.items,
          pagination:
            action.Payload.pagination ?? state.completedForms.pagination,
          filterFormID:
            action.Payload.filterFormID ?? state.completedForms.filterFormID,
          error: null,
        },
      };

    case GET_COMPLETED_FORM_BY_ID:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          currentCompletedForm: action.Payload,
          error: null,
        },
      };

    case SUBMIT_COMPLETED_FORM:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          items: [action.Payload, ...state.completedForms.items],
          currentCompletedForm: action.Payload,
          pagination: {
            ...state.completedForms.pagination,
            total: state.completedForms.pagination.total + 1,
          },
          error: null,
        },
      };

    case REPLY_COMPLETED_FORM:
    case SET_COMPLETED_FORM_TICKET_STATUS:
    case SET_COMPLETED_FORM_WORKFLOW_STATE:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          items: updateCompletedFormInList(
            state.completedForms.items,
            action.Payload,
          ),
          currentCompletedForm: action.Payload,
          error: null,
        },
      };

    case DELETE_COMPLETED_FORM:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          items: removeCompletedFormFromList(
            state.completedForms.items,
            action.Payload,
          ),
          currentCompletedForm:
            state.completedForms.currentCompletedForm?._id === action.Payload
              ? null
              : state.completedForms.currentCompletedForm,
          pagination: {
            ...state.completedForms.pagination,
            total: Math.max(0, state.completedForms.pagination.total - 1),
          },
          error: null,
        },
      };

    case CLEAR_COMPLETED_FORMS_STATE:
      return {
        ...state,
        completedForms: INITIAL_COMPLETED_FORMS_STATE,
      };

    case CLEAR_CURRENT_COMPLETED_FORM:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          currentCompletedForm: null,
        },
      };

    case SET_FORM_RESPONSE_STATS_LOADING:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          formResponseStatsLoading: action.Payload,
        },
      };

    case SET_FORM_RESPONSE_STATS_ERROR:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          formResponseStatsError: action.Payload,
          formResponseStatsLoading: false,
        },
      };

    case GET_FORM_RESPONSE_STATS:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          formResponseStats: action.Payload,
          formResponseStatsError: null,
          formResponseStatsLoading: false,
        },
      };

    case CLEAR_FORM_RESPONSE_STATS:
      return {
        ...state,
        completedForms: {
          ...state.completedForms,
          formResponseStats: null,
          formResponseStatsError: null,
          formResponseStatsLoading: false,
        },
      };

    case SET_FORM_CATEGORIES_LOADING:
      return {
        ...state,
        categoriesLoading: action.Payload,
      };

    case SET_FORM_CATEGORIES_ERROR:
      return {
        ...state,
        categoriesError: action.Payload,
        categoriesLoading: false,
      };

    case GET_FORM_CATEGORIES:
      return {
        ...state,
        categories: Array.isArray(action.Payload) ? action.Payload : [],
        categoriesError: null,
        categoriesLoading: false,
      };

    case SET_FORM_DEPARTMENTS_LOADING:
      return {
        ...state,
        departmentsLoading: action.Payload,
      };

    case SET_FORM_DEPARTMENTS_ERROR:
      return {
        ...state,
        departmentsError: action.Payload,
        departmentsLoading: false,
      };

    case GET_FORM_DEPARTMENTS:
      return {
        ...state,
        departments: Array.isArray(action.Payload) ? action.Payload : [],
        departmentsError: null,
        departmentsLoading: false,
      };

    case SET_FORM_STATUSES_LOADING:
      return {
        ...state,
        statusesLoading: action.Payload,
      };

    case SET_FORM_STATUSES_ERROR:
      return {
        ...state,
        statusesError: action.Payload,
        statusesLoading: false,
      };

    case GET_FORM_STATUSES:
      return {
        ...state,
        statuses: Array.isArray(action.Payload) ? action.Payload : [],
        statusesError: null,
        statusesLoading: false,
      };

    case SET_PUBLIC_FORM_LOADING:
      return {
        ...state,
        publicFormLoading: action.Payload,
      };

    case SET_PUBLIC_FORM_ERROR:
      return {
        ...state,
        publicFormError: action.Payload,
        publicFormLoading: false,
      };

    case GET_PUBLIC_FORM_BY_ID:
      return {
        ...state,
        publicForm: action.Payload,
        publicFormError: null,
        publicFormLoading: false,
      };

    case CLEAR_PUBLIC_FORM:
      return {
        ...state,
        publicForm: null,
        publicFormError: null,
        publicFormSubmitLoading: false,
        publicFormSubmitError: null,
        publicFormSubmitted: null,
        publicFormRecord: null,
        publicFormRecordLoading: false,
        publicFormRecordError: null,
      };

    case SET_PUBLIC_FORM_SUBMIT_LOADING:
      return {
        ...state,
        publicFormSubmitLoading: action.Payload,
      };

    case SET_PUBLIC_FORM_SUBMIT_ERROR:
      return {
        ...state,
        publicFormSubmitError: action.Payload,
        publicFormSubmitLoading: false,
      };

    case SUBMIT_PUBLIC_FORM:
      return {
        ...state,
        publicFormSubmitted: action.Payload,
        publicFormSubmitError: null,
        publicFormSubmitLoading: false,
      };

    case SET_PUBLIC_FORM_RECORD_LOADING:
      return {
        ...state,
        publicFormRecordLoading: action.Payload,
      };

    case SET_PUBLIC_FORM_RECORD_ERROR:
      return {
        ...state,
        publicFormRecordError: action.Payload,
        publicFormRecordLoading: false,
      };

    case GET_PUBLIC_FORM_RECORD:
    case PUBLIC_FORM_RECORD_REPLY:
      return {
        ...state,
        publicFormRecord: action.Payload,
        publicFormRecordError: null,
        publicFormRecordLoading: false,
      };

    default:
      return state;
  }
};
